import { useEffect, useState } from "react";
import { IconX } from "@tabler/icons-react";

const PhotoAlbumTagger = ({ picture, folders, onCreateFolder, onAddToFolder, onRemoveFromFolder }) => {
    const [query, setQuery] = useState("");
    const [highlightedIndex, setHighlightedIndex] = useState(0);

    const trimmed = query.trim();
    const matches = picture && trimmed
        ? folders.filter(f =>
            f.name.toLowerCase().includes(trimmed.toLowerCase()) &&
            !f.pictureIds.includes(picture._id)
        )
        : [];
    const exactMatch = picture ? folders.some(f => f.name.toLowerCase() === trimmed.toLowerCase()) : true;
    const showCreateOption = trimmed.length > 0 && !exactMatch;
    const optionCount = matches.length + (showCreateOption ? 1 : 0);

    useEffect(() => {
        setHighlightedIndex(0);
    }, [query]);

    if (!picture) return null;

    const pictureFolders = folders.filter(f => f.pictureIds.includes(picture._id));

    const pick = (folder) => {
        onAddToFolder(folder._id);
        setQuery("");
    };

    const createAndTag = async () => {
        const created = await onCreateFolder(trimmed);
        if (created) onAddToFolder(created._id);
        setQuery("");
    };

    const selectHighlighted = () => {
        if (highlightedIndex < matches.length) pick(matches[highlightedIndex]);
        else if (showCreateOption) createAndTag();
    };

    const handleKeyDown = (e) => {
        if (optionCount === 0) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev) => (prev + 1) % optionCount);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev) => (prev - 1 + optionCount) % optionCount);
        } else if (e.key === "Enter") {
            e.preventDefault();
            selectHighlighted();
        }
    };

    return (
        <div className="photo-album-tagger" onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
            {pictureFolders.length > 0 && (
                <div className="photo-album-tagger-chips">
                    {pictureFolders.map((folder) => (
                        <span className="photo-album-chip" key={folder._id}>
                            {folder.name}
                            <button type="button" onClick={() => onRemoveFromFolder(folder._id)}>
                                <IconX size={12} />
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <div className="photo-album-tagger-search">
                <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Add to album..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
                {trimmed.length > 0 && (
                    <div className="photo-album-tagger-dropdown">
                        {matches.map((folder, i) => (
                            <div
                                className={`photo-album-tagger-option ${i === highlightedIndex ? "photo-album-tagger-option-active" : ""}`}
                                key={folder._id}
                                onMouseEnter={() => setHighlightedIndex(i)}
                                onClick={() => pick(folder)}
                            >
                                {folder.name}
                            </div>
                        ))}
                        {showCreateOption && (
                            <div
                                className={`photo-album-tagger-option photo-album-tagger-create ${matches.length === highlightedIndex ? "photo-album-tagger-option-active" : ""}`}
                                onMouseEnter={() => setHighlightedIndex(matches.length)}
                                onClick={createAndTag}
                            >
                                + Create "{trimmed}"
                            </div>
                        )}
                        {matches.length === 0 && !showCreateOption && (
                            <div className="photo-album-tagger-option text-muted">Already tagged</div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PhotoAlbumTagger;
